"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _complementary = _interopRequireDefault(require("./complementary"));

var _cnpTypography = _interopRequireDefault(require("./cnp-typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var cnpBaseTheme = {
  name: 'cnp-assurances',
  version: '1.0.0',
  color: {
    brandPrimary: {
      dark: '#000D26',
      medium: '#001845',
      light: '#002364',
      gradient: 'linear-gradient(224.34deg, #CCD3E0 -50.46%, #002364 62.35%)'
    },
    brandSecondary: {
      dark: '#7A0039',
      medium: '#A3004C',
      light: '#D70064',
      gradient: 'linear-gradient(224.34deg, #F7CCE0 -50.46%, #D70064 62.35%)'
    },
    brandTertiary: {
      dark: '#006E67',
      medium: '#008C84',
      light: '#00B4AA',
      gradient: 'linear-gradient(224.34deg, #66D2CC -50.46%, #0084AA 62.35%)'
    },
    support: {
      '01': '#5692CE',
      '02': '#F08100',
      '03': '#5D2F88'
    },
    neutral: {
      '01': '#282E2E',
      '02': '#454E4F',
      '03': '#6C757D',
      '04': '#A5B3B7',
      '05': '#C6C2C5',
      '06': '#E3E0E2',
      '07': '#F4F3F3',
      '08': '#FFFFFF'
    },
    feedback: {
      success: '#5B8E00',
      alert: '#E89800',
      error: '#DC3545'
    },
    background: {
      dark: '#282E2E',
      light: '#F4F3F3'
    },
    highlight: {
      '01': '#F08100',
      '02': '#5D2F88',
      '03': '#78D64B',
      '04': '#5692CE',
      '05': '#5465FF',
      '06': '#861657',
      '07': '#AA4131',
      '08': '#606C38'
    },
    line: {
      dark: '#282E2E',
      medium: '#E3E0E2',
      light: '#FFFFFF',
      primary: '#D70064',
      secondary: '#00B4AA'
    }
  },
  font: {
    family: {
      highlight: 'Rawline',
      base: 'Rawline'
    },
    size: {
      '2xs': '12px',
      xs: '14px',
      sm: '16px',
      md: '18px',
      lg: '20px',
      xl: '24px',
      '2xl': '28px',
      '3xl': '32px',
      '4xl': '36px',
      '5xl': '40px',
      '6xl': '48px',
      '7xl': '64px'
    },
    weight: {
      '3xs': '100',
      '2xs': '200',
      xs: '400',
      sm: '500',
      md: '700',
      lg: '500',
      xl: '800',
      '2xl': '800',
      '3xl': '900'
    },
    decoration: {
      none: 'none',
      italic: 'italic',
      underline: 'underline',
      strikethrough: 'strikethrough'
    },
    transform: {
      none: 'none',
      uppercase: 'uppercase',
      lowercase: 'lowercase',
      capitalize: 'capitalize'
    }
  },
  line: {
    height: {
      sm: '100%',
      md: '125%',
      lg: '150%',
      xl: '160%',
      '2xl': '175%',
      '3xl': '200%'
    }
  },
  letter: {
    spacing: {
      sm: '0',
      md: '1px',
      lg: '2px',
      xl: '3px',
      '2xl': '4px'
    }
  }
};

var cnpTheme = _extends({}, cnpBaseTheme, (0, _cnpTypography["default"])(cnpBaseTheme), (0, _complementary["default"])(cnpBaseTheme));

var _default = cnpTheme;
exports["default"] = _default;